//@vendor
const { createActions } = require('redux-actions');
const { APIPost } = require('utilities/APIRequestHelper');
// @core
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
//@utilities
const { APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const { getURL } = require('core/apiURLBuilder');
const download = require('downloadjs');
const {
    PROC_END,
    PROC_FAIL,
    PROC_HIRE_PRE_GRANTED_CREDIT,
    recordProcess
} = require('utilities/tagging');
const { buildLabels } = require('loansUtilities/loansHelper');

// @constants
const {
    PRE_GRANTED_CREDIT_STANDARD,
    PRE_GRANTED_CREDIT_SUBTYPE,
    PRE_GRANTED_CREDIT_TYPE,
    OVERDRAFT_LOAN_TYPE,
    OVERDRAFT_LOAN_SUBTYPE,
    OVERDRAFT_LOAN_STANDARD,
    OVERDRAFT_LOAN_MAILTYPE,
} = require('constants/index');
const translationContractLoanPdfViewerINE = require("../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");
const {
    OVERDRAFT_PROTECTION_LEGAL_CHECK,
    EVIDENCE_OVERDRAFT
} = require('constants/flagBasedFeatures');
const {
    LANGUAGE,

    preGrantedCreditEmail: {
        PRODUCT,
        STANDARD,
        SUBPRODUCT,
        TEMPLATE_CODE,
    },
} = require('../loansConstants/index').preGrantedCredit;
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

//@actions
const { validateAndExecute } = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');

// Actions in alphabetic order
const simpleActions = createActions(
    'CONTRACT_PRE_GRANTED_CREDIT_AGREE_RESET',
    'CONTRACT_PRE_GRANTED_CREDIT_AGREE_TOGGLE',

    'CONTRACT_PRE_GRANTED_CREDIT_DOCUMENT_DOWNLOAD',
    'CONTRACT_PRE_GRANTED_CREDIT_DOCUMENT_DOWNLOAD_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_DOCUMENT_DOWNLOAD_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_FORMALIZE',
    'CONTRACT_PRE_GRANTED_CREDIT_FORMALIZE_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_FORMALIZE_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_GET_CONTRACT_INFORMATION',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_CONTRACT_INFORMATION_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_CONTRACT_INFORMATION_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_GET_PRECONTRACTUAL_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_GET_DOCUMENT',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_DOCUMENT_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_DOCUMENT_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_RESET_STATE',

    'CONTRACT_PRE_GRANTED_CREDIT_SET_SELETED_ACCOUNT',
    'CONTRACT_PRE_GRANTED_CREDIT_SET_LOAN_AMOUNT',

    'CONTRACT_PRE_GRANTED_CREDIT_SET_VISIBLE_STEP',

    'CONTRACT_PRE_GRANTED_CREDIT_UPDATE_CONFIRMATION_CHECKBOX',

    'CONTRACT_PRE_GRANTED_CREDIT_VALIDATE_STEP',

    'CONTRACT_PRE_GRANTED_CREDIT_PRECONTRACTUAL_EMAIL',
    'CONTRACT_PRE_GRANTED_CREDIT_PRECONTRACTUAL_EMAIL_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_PRECONTRACTUAL_EMAIL_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_GET_INE_DOCUMENT',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_INE_DOCUMENT_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_INE_DOCUMENT_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_GET_DRAFT_DOCUMENT',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_DRAFT_DOCUMENT_ERROR',
    'CONTRACT_PRE_GRANTED_CREDIT_GET_DRAFT_DOCUMENT_SUCCESS',

    'CONTRACT_PRE_GRANTED_CREDIT_OVER_DRAFT_INIT_LOADING',
    'CONTRACT_PRE_GRANTED_CREDIT_OVER_DRAFT_INIT_ONE_SUCCESS',
    'CONTRACT_PRE_GRANTED_CREDIT_OVER_DRAFT_INIT_TWO_SUCCESS',
    'CONTRACT_PRE_GRANTED_CREDIT_OVER_DRAFT_INIT_ERROR',

    'CONTRACT_OVERDRAFT_EMAIL_LOADING',
    'CONTRACT_OVERDRAFT_EMAIL_SUCCESS',
    'CONTRACT_OVERDRAFT_EMAIL_ERROR',

    'ACCOUNT_TIN_TAE_SUCCESS',
    'ACCOUNT_TIN_TAE_ERROR',
    'SET_INIT_API_FLAG',
    'CONTRACT_PRE_GRANTED_CREDIT_OFFICE_PRINT',
    'OFFICE_PRINT_RESET',
    'RESET_MAIL_SENT',
    'CONTRACT_PRE_GRANTED_CREDIT_OFFICE_CONTRACT_PRINT',
    'CONTRACT_PRE_GRANTED_CREDIT_READ_DOCUMENT',
    'CONTRACT_PRE_GRANTED_CREDIT_CHECK_RADIO_BUTTON_STEP_THREE',
    'CONTRACT_PRE_GRANTED_CREDIT_CHECK_RADIO_BUTTON_STEP_FOUR',
);

const getContractInformation = () => (dispatch, getState) => {
    const isFetching = getState().contractPreGrantedCredit.get('isFetching');

    if (isFetching) return;

    const language = getLanguage().toUpperCase();
    const deviceInd = __CONTACT_CENTER__ ? 'cc' : 'default';

    dispatch(simpleActions.contractPreGrantedCreditGetContractInformation());

    APIGet(dispatch, `${getURL('campaignEngine')}/${deviceInd}/${language}/uncovered-protection/1`)
        .then(response => {
            dispatch(simpleActions.contractPreGrantedCreditGetContractInformationSuccess({ response: response[0].body.value }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPreGrantedCreditGetContractInformationError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const onDownloadDocument = () => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const fileZip = immContracts.get('fileZip');
    const isFetchingZip = immContracts.get('isFetchingZip');
    const fileName = 'DocumentosProteccionDescubierto.zip';

    if (fileZip) {
        download(fileZip, fileName, 'application/zip');
    } else if (!isFetchingZip) {
        const params = {
            header: {
                responseType: 'arraybuffer'
            }
        };

        dispatch(simpleActions.contractPreGrantedCreditDocumentDownload());
        APIGet({ dispatch, endpoint: 'pregrantedCreditHiringDocumentsZip', params })
            .then(document => {
                const response = document.xhr.response;
                dispatch(simpleActions.contractPreGrantedCreditDocumentDownloadSuccess({ response }));
                download(response, fileName, 'application/zip');
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractPreGrantedCreditDocumentDownloadError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const onPrintDocument = (document) => (dispatch, getState) => {
    if (isPrintOfficeMode()) {
        document ? dispatch(simpleActions.contractPreGrantedCreditOfficePrint()) :
            dispatch(simpleActions.contractPreGrantedCreditOfficeContractPrint());
    }
};

const getHiringDocuments = () => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const file = immContracts.get('file');

    if (!!file) {
        return;
    }

    const params = {
        header: {
            responseType: 'arraybuffer'
        }
    };

    dispatch(simpleActions.contractPreGrantedCreditGetDocument());
    APIGet({ dispatch, endpoint: 'pregrantedCreditHiringDocuments', params })
        .then(response => {
            dispatch(simpleActions.contractPreGrantedCreditGetDocumentSuccess({ response: response.xhr.response }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPreGrantedCreditGetDocumentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getPrecontractual = () => dispatch => {
    const requestData = {
        query: {
            estandar: PRE_GRANTED_CREDIT_STANDARD,
            idioma: LANGUAGE,
            subtipo: PRE_GRANTED_CREDIT_SUBTYPE,
            tipo: PRE_GRANTED_CREDIT_TYPE
        }
    };

    APIGet(dispatch, getURL('requestPreContractActive'), requestData)
        .then(response => dispatch(simpleActions.contractPreGrantedCreditGetPrecontractualSuccess({ response })));
};

const getDocumentParams = (tinAccount, taeAccount) => (dispatch, getState) => {
    const globalParams = getState().globalVariables.getIn(['variables', 'parameters'])

    const immContracts = getState().contractPreGrantedCredit;
    const amount = immContracts.get('selectedAmount').toString();
    const immAccount = getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const ibanComplex = immAccount.get('ibanComplex');
    const tae = globalParams.getIn(['proteccion_descubierto', 'tae']).slice(0, -1);
    const tin = globalParams.getIn(['proteccion_descubierto', 'tin']).slice(0, -1);
    const account = `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const monthlyTin = globalParams.getIn(['proteccion_descubierto', 'tin_mensual']).slice(0, -1);
    const params = {
        amount,
        tae,
        tin,
        monthlyTin,
        account,
        taeAccount,
        tinAccount
    }

    return params;

}

const getOverdraftInitTwo = () => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const immAccount = getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const ibanComplex = immAccount.get('ibanComplex');
    const contractNumberAccount = ibanComplex.get('codbban');
    const tinAccount = immContracts.get('tinAccount');
    const taeAccount = immContracts.get('taeAccount');
    const operationProcessId = immContracts.get('operationProcessIdINE');
    dispatch(simpleActions.contractPreGrantedCreditOverDraftInitLoading());
    const params = {
        query: {
            ...dispatch(getDocumentParams(tinAccount, taeAccount)),
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE
            },
            contractNumberAccount,
            processType: OVERDRAFT_LOAN_MAILTYPE.CONTRACTUAL,
            attachedEvidences: [operationProcessId]
        }
    }
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.contractPreGrantedCreditOverDraftInitTwoSuccess({ operationProcessIdPolicy: response.operationProcessId }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPreGrantedCreditOverDraftInitError());
            } else {
                throw response;
            }
        });
};

const getOverdraftInitOne = () => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const immAccount = getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const ibanComplex = immAccount.get('ibanComplex');
    const contractNumberAccount = ibanComplex.get('codbban');

    const tinTaeParams = {
        query: {
            type: immAccount.get('newProduct'),
            subtype: immAccount.get('accountType')
        }
    }

    dispatch(simpleActions.contractPreGrantedCreditOverDraftInitLoading());

    APIPost({
        params: tinTaeParams,
        dispatch,
        url: apiURLBuilder.getURL('getAccountTinTae', { contractNumber: immAccount.get('contractNumber') }),
    })
        .then(response => {

            const { debtorTin, debtorTae } = response
            dispatch(simpleActions.accountTinTaeSuccess({ tinAccount: debtorTin, taeAccount: debtorTae }));
            const params = {
                query: {
                    ...dispatch(getDocumentParams(debtorTin, debtorTae)),
                    product: {
                        standard: OVERDRAFT_LOAN_STANDARD,
                        subType: OVERDRAFT_LOAN_SUBTYPE,
                        type: OVERDRAFT_LOAN_TYPE
                    },
                    contractNumberAccount,
                    processType: OVERDRAFT_LOAN_MAILTYPE.PRECONTRACTUAL
                }
            }
            return APIPost({
                dispatch,
                endpoint: 'overdraftInit',
                params
            })
                .then((response) => {
                    dispatch(simpleActions.contractPreGrantedCreditOverDraftInitOneSuccess({ operationProcessIdINE: response.operationProcessId }));
                    dispatch(getINEDocument())

                })
                .catch(response => {
                    if (!!response.error) {
                        dispatch(simpleActions.contractPreGrantedCreditOverDraftInitError());
                    } else {
                        throw response;
                    }
                });
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.accountTinTaeError());
            } else {
                throw response;
            }
        });
}

const getINEDocument = () => (dispatch, getState) => {
    /** 
     * add the code for get the INE docuemnt
     */

    const immContracts = getState().contractPreGrantedCredit;
    const operationProcessId = immContracts.get('operationProcessIdINE');
    const tinAccount = immContracts.get('tinAccount');
    const taeAccount = immContracts.get('taeAccount');
    const immAccount = getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const tinTaeParams = {
        query: {
            type: immAccount.get('newProduct'),
            subtype: immAccount.get('accountType')
        }
    }
    const params = {
        query: {
            ...dispatch(getDocumentParams(tinAccount, taeAccount)),
            operationProcessId
        }
    }
    dispatch(simpleActions.contractPreGrantedCreditGetIneDocument());
    APIPost({ params, dispatch, url: apiURLBuilder.getURL('getOverdraftLoanINEDocument') })
        .then(response => {
            dispatch(simpleActions.contractPreGrantedCreditGetIneDocumentSuccess({ base64Document: response.base64Document, temporaryDocumentId: response.temporaryDocumentId }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPreGrantedCreditGetIneDocumentError({ error: response.error }));
            } else {
                throw response;
            }
        });
}

const sendOverDraftSimpleEmail = (mailType, documentId) => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const immAccount = getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const ibanComplex = immAccount.get('ibanComplex');
    const contractNumberAccount = ibanComplex.get('codbban');
    const operationProcessId = mailType === OVERDRAFT_LOAN_MAILTYPE.PRECONTRACTUAL ? immContracts.get('operationProcessIdINE') : immContracts.get('operationProcessIdPolicy');
    const acceptanceText = mailType !== OVERDRAFT_LOAN_MAILTYPE.PRECONTRACTUAL && (__CONTACT_CENTER__) ? 'NA' : mailType !== OVERDRAFT_LOAN_MAILTYPE.PRECONTRACTUAL && !__CONTACT_CENTER__ ? formatText(translationContractLoanPdfViewerINE.TITLE_CONTRACT_DRAFT_DOCUMENT) : isPrintOfficeMode() && __CONTACT_CENTER__ ? formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX_DEFAULT) : __CONTACT_CENTER__ && !isPrintOfficeMode() ? buildLabels() : formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX);
    const scrollDown = immContracts.get('scrollDown');
    const params = !!documentId && {
        query: {
            mailType: mailType,
            documentId: documentId,
            scrollDown,
            product: {
                standard: OVERDRAFT_LOAN_STANDARD,
                subType: OVERDRAFT_LOAN_SUBTYPE,
                type: OVERDRAFT_LOAN_TYPE
            },
            contractNumberAccount,
            operationProcessId,
            acceptanceText
        }

    };
    dispatch(simpleActions.contractOverdraftEmailLoading());
    APIPost({
        dispatch,
        endpoint: 'sendOverDraftSimpleEmail',
        params
    })
        .then(() => {
            dispatch(simpleActions.contractOverdraftEmailSuccess());
            __CONTACT_CENTER__ && !isPrintOfficeMode() && dispatch(getOverdraftInitTwo()).then(() => {
                dispatch(getContractDraftDocument(true));
            });
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractOverdraftEmailError());
            } else {
                throw response;
            }
        });
}

const getContractDraftDocument = (flag) => (dispatch, getState) => {
    /** 
     * add the code for get the Contract draft
    */
    const immContracts = getState().contractPreGrantedCredit;
    const immAccount = !!flag && getState().accounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const ibanComplex = !!flag && immAccount.get('ibanComplex');
    const contractNumberAccount = !!flag && ibanComplex.get('codbban');
    const operationProcessId = !!flag && immContracts.get('operationProcessIdPolicy');
    const account = !!flag && `${ibanComplex.get('pais')}${ibanComplex.get('digitodecontrol')}${ibanComplex.get('codbban')}`;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const tinAccount = !!flag && immContracts.get('tinAccount');
    const taeAccount = !!flag && immContracts.get('taeAccount');
    const params = !!flag && immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT) ?
        {
            query: { ...dispatch(getDocumentParams(tinAccount, taeAccount)), contractNumberAccount, operationProcessId }
        } : !!flag && !immFlagBasedFeatures.get(EVIDENCE_OVERDRAFT) ? {
            query: { ...dispatch(getDocumentParams(tinAccount, taeAccount)), account, contractNumberAccount, operationProcessId }
        } : !flag && {
            header: {
                responseType: 'arraybuffer'
            }
        };

    dispatch(simpleActions.contractPreGrantedCreditGetDraftDocument());

    if (!!flag) {
        APIPost({ params, dispatch, url: apiURLBuilder.getURL('contractDocumentPolicy') })
            .then(response => {
                dispatch(simpleActions.contractPreGrantedCreditGetDraftDocumentSuccess({ base64Document: response.base64Document, temporaryDocumentId: response.temporaryDocumentId, flag }));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractPreGrantedCreditGetDraftDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
    else {
        APIGet({ dispatch, endpoint: 'pregrantedCreditHiringDocuments', params })
            .then(response => {
                dispatch(simpleActions.contractPreGrantedCreditGetDraftDocumentSuccess({ response: response.xhr.response, flag }));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractPreGrantedCreditGetDraftDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });

    }

};

const sendLoansBarePrecontractualEmail = () => dispatch => {
    dispatch(simpleActions.contractPreGrantedCreditPrecontractualEmail());
    const params = {
        query: {
            producto: PRODUCT,
            standard: STANDARD,
            subproducto: SUBPRODUCT,
            templateCode: TEMPLATE_CODE,
        }
    };
    return APIPost({
        dispatch,
        endpoint: 'sendPrecontractualDocumentMail',
        params
    })
        .then(() => {
            dispatch(simpleActions.contractPreGrantedCreditPrecontractualEmailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPreGrantedCreditPrecontractualEmailError());
            } else {
                throw response;
            }
        });
}

const setInitApiFlag = (initFlag, mailFlag, checkboxFlag, btnFlag) => dispatch => {
    dispatch(simpleActions.setInitApiFlag({ initFlag, mailFlag, checkboxFlag, btnFlag }))
}

const officePrintReset = (officePrintStepThree) => dispatch => {
    dispatch(simpleActions.officePrintReset({ officePrintStepThree }))
}

const resetMailSent = (resetMailSent) => dispatch => {
    dispatch(simpleActions.resetMailSent({ resetMailSent }))
}

const formalize = (immAccounts) => (dispatch, getState) => {
    const immContracts = getState().contractPreGrantedCredit;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immAccount = immAccounts.getIn(['byId', immContracts.get('selectedAccount')]);
    const operationProcessId = immContracts.get('operationProcessIdPolicy');
    const officeSignature = isPrintOfficeMode();
    const documentId = immContracts.get('contractDocumentId');
    const acceptanceText = __CONTACT_CENTER__
        ? (isPrintOfficeMode()
            ? formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX_DEFAULT)
            : buildLabels())
        : formatText(translationContractLoanPdfViewerINE.TITLE_CONTRACT_DRAFT_DOCUMENT);
    const scrollDown = immContracts.get('scrollDown');
    const ibanComplex = immAccount.get('ibanComplex');

    const formalizeCallback = (tokenFirma) => {
        const params = {
            header: {
                version: 2
            },
            query: {
                tokenFirma,
                contratoSeleccionado: {
                    numerodecontrato: immAccount.get('contractNumber'),
                    producto: immAccount.get('product'),
                },
                impConced: {
                    divisa: immContracts.get('currency'),
                    importe: immContracts.get('selectedAmount')
                },
                termsAndConds: {},
                acceptanceText,
                scrollDown,
                documentId,
                contractNumberAccount: ibanComplex.get('codbban'),
                operationProcessId
            }
        };

        if (immFlagBasedFeatures.get(OVERDRAFT_PROTECTION_LEGAL_CHECK)) {
            const acceptedTextSplit = formatText('contractConfirmationStep-contractConfirmationStep_pregrantedCreditAgreeCheckboxLabel').split('%s');
            const injectedLinks = [
                formatText('contractConfirmationStep-contractConfirmationStep_pregrantedCreditIneDocument'),
                formatText('contractConfirmationStep-contractConfirmationStep_pregrantedCreditContractDocument')
            ];

            let acceptedText = '';
            acceptedTextSplit.map((message, index) => {
                const text = injectedLinks[index];
                const textValue = text ? text : '';
                acceptedText += message + textValue;
            });

            const termsAndConds = {
                acceptedText,
                dateTimeToSave: immContracts.get('timesTampCheckBox'),
            }
            params.query.termsAndConds = termsAndConds;
        }

        dispatch(simpleActions.contractPreGrantedCreditFormalize());
        return APIPost(dispatch, apiURLBuilder.getURL('hireImmediateCredit'), params)
            .then(response => {
                recordProcess(PROC_HIRE_PRE_GRANTED_CREDIT, PROC_END);
                dispatch(simpleActions.contractPreGrantedCreditFormalizeSuccess({ response }));
            })
            .catch(response => {
                if (!!response.error) {
                    recordProcess(PROC_HIRE_PRE_GRANTED_CREDIT, PROC_FAIL);
                    dispatch(simpleActions.contractPreGrantedCreditFormalizeError({ response }))
                } else {
                    throw response;
                }
            });
    };

    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => formalizeCallback(dataToken))
            .catch(() => formalizeCallback(dataToken));
    };

    !!officeSignature ? validateAndExecute(dispatch, getState, callback, true)
        : validateAndExecute(dispatch, getState, callback, false);
}
const checkReadDocument = () => (dispatch, getState) => {
    dispatch(simpleActions.contractPreGrantedCreditReadDocument());
}

const checkRadioButtonOfficeStepThree = (check) => (dispatch, getState) => {
    dispatch(simpleActions.contractPreGrantedCreditCheckRadioButtonStepThree(check));
}

const checkRadioButtonOfficeStepFour = (check) => (dispatch, getState) => {
    dispatch(simpleActions.contractPreGrantedCreditCheckRadioButtonStepFour(check));
}

module.exports = {
    formalize,
    getOverdraftInitOne,
    getOverdraftInitTwo,
    getContractInformation,
    getHiringDocuments,
    getINEDocument,
    sendOverDraftSimpleEmail,
    getContractDraftDocument,
    getPrecontractual,
    onDownloadDocument,
    onPrintDocument,
    sendLoansBarePrecontractualEmail,
    setInitApiFlag,
    officePrintReset,
    resetMailSent,
    simpleActions,
    checkReadDocument,
    checkRadioButtonOfficeStepThree,
    checkRadioButtonOfficeStepFour
};
